/**
 * Polyfill for Promise.withResolvers()
 *
 * Promise.withResolvers is an ES2024 feature that may not be available in older
 * JavaScript runtimes, including the embedded browsers used by Office add-ins.
 *
 * This polyfill provides the missing functionality to ensure compatibility with
 * libraries (like Keycloak) that depend on this feature.
 *
 * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Promise/withResolvers
 */

interface PromiseWithResolvers<T> {
  promise: Promise<T>;
  resolve: (value: T | PromiseLike<T>) => void;
  reject: (reason?: any) => void;
}

declare global {
  interface PromiseConstructor {
    withResolvers<T>(): PromiseWithResolvers<T>;
  }
}

if (typeof Promise.withResolvers === "undefined") {
  Promise.withResolvers = function <T>(): PromiseWithResolvers<T> {
    let resolve!: (value: T | PromiseLike<T>) => void;
    let reject!: (reason?: any) => void;

    const promise = new Promise<T>((res, rej) => {
      resolve = res;
      reject = rej;
    });

    return { promise, resolve, reject };
  };
}

export {};
